import { API } from "../../constants/APIConstants";
import { callAPI } from "../../config/AxiosTemplate";

export const getCollectionExpenseHistoryAction = (
  loanId,
  filters,
  callback
) => {
  callAPI(
    "getCollectionExpenseHistory",
    API.getCollectionExpenseHistory + loanId,
    "POST",
    filters,
    callback
  );
};

export const downloadCollectionExpenseHistoryAction = (
  loanId,
  fileType,
  filters,
  callback
) => {
  callAPI(
    "getCollectionExpenseHistory",
    API.getCollectionExpenseHistory + loanId + "/download?fileType=" + fileType,
    "POST",
    filters,
    callback,
    true
  );
};
